import React,{useState, useEffect} from 'react'

import { onAuthStateChanged } from "firebase/auth";
import { useSelector } from 'react-redux';
import Messenger from '../Messenger/Messenger';
import {Close, MsgIcon} from '../layout/Icons'

import { addUserToRoom, auth, ensureFirebaseSession } from '../../config/firebaseConfig';
import NotificationCircle from './NotificationCircle';

const SideBar = () => {

const [uid,setuid]=useState(null); 
const user=useSelector((state=>state.user.value));
const companies=useSelector((state=>state.company.value));
const [unread,setUnread]=useState(-1);
const [showSidebar, setShowSidebar]=useState(false);
const [chatCollapsed, setChatCollapsed]=useState(()=>localStorage.getItem('escapeChatSidebarCollapsed') === 'true');
const [firebaseLoading,setFirebaseLoading]=useState(true);
const [firebaseError,setFirebaseError]=useState('');

useEffect(()=>{
  const unsubscribe=onAuthStateChanged(auth, (user) => {
    if (user) {
      const uid = user.uid;
      setuid(uid);
    }else{
      setuid(null);
    }
  });
  return()=>unsubscribe()
},[])

useEffect(()=>{
  document.body.classList.toggle('chat-sidebar-collapsed', chatCollapsed);
  localStorage.setItem('escapeChatSidebarCollapsed', chatCollapsed ? 'true' : 'false');
  return()=>document.body.classList.remove('chat-sidebar-collapsed');
},[chatCollapsed])

useEffect(()=>{
  const syncFirebase=async()=>{
    if(!user?.id){
      setFirebaseLoading(false);
      return;
    }
    setFirebaseLoading(true);
    setFirebaseError('');
    try{
      if(!auth.currentUser && user.f_tokenId){
        await ensureFirebaseSession(user.email, user.f_tokenId, user.id);
      }
      if(companies.length>0){
        await Promise.all(companies.map((company)=>addUserToRoom(
          company.id,
          user.id,
          `${user.Fname} ${user.Lname}`,
          user.image || null
        )));
      }
    }catch(error){
      console.warn('Firebase chat sync failed', error);
      if(error?.code==='auth/operation-not-allowed'){
        setFirebaseError('Firebase anonymous sign-in is disabled. Enable it or remove the stale Firebase account for this email.');
      }else if(error?.originalFirebaseError?.code==='auth/wrong-password' || error?.code==='auth/wrong-password'){
        setFirebaseError('Firebase has a stale account for this email. Chat is using fallback auth when available.');
      }else{
        setFirebaseError('Chat is reconnecting. Please refresh if it stays unavailable.');
      }
    }finally{
      setFirebaseLoading(false);
    }
  }
  syncFirebase();
},[user?.id, user?.f_tokenId, companies])


  
  return (
    <>
    <div className='fixed bottom-10 right-5 z-[99] 2xl:hidden block'>
      <button onClick={()=>{setShowSidebar(!showSidebar)}} className={`msgToggleBtn ${showSidebar? `scale-0` : `scale-100`} origin-center`}>
          <MsgIcon iconClass={'w-7 h-7'} />
         <NotificationCircle value={unread}/>
      </button>

    </div>
    <div className={`sidebarRight ${chatCollapsed ? 'chat-collapsed' : ''} 2xl:right-0 ${showSidebar? `right-0 opacity-100` : `-right-full opacity-0`} 2xl:opacity-100`}>
        {firebaseLoading || uid==null ?
          <div className='messenger-auth-state'>
            <button
              type='button'
              className='messenger-mobile-close messenger-auth-close'
              onClick={()=>setShowSidebar(false)}
              title='Close messages'
            >
              <Close iconClass={'w-4 h-4'}/>
            </button>
            <div className='messenger-auth-spinner'></div>
            <p>Connecting chat</p>
            {firebaseError?<span>{firebaseError}</span>:null}
          </div>
          :
          <Messenger
            showSidebar={showSidebar}
            setShowSidebar={setShowSidebar}
            setUnread={setUnread}
            chatCollapsed={chatCollapsed}
            setChatCollapsed={setChatCollapsed}
          />
        }

        {/* <button className='info-btn' onClick={()=>{addRoom(2,'test',8, '', 'Jhon')}}>Test Room</button> */}
    </div>
    </>

  )
}

export default SideBar
